import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, CheckCircleIcon } from 'lucide-react';
interface ArtifactCardProps {
  title: string;
  description: string;
  price: string;
  selected: boolean;
  onToggle: () => void;
  signColor: string;
  isBundle?: boolean;
}
export function ArtifactCard({
  title,
  description,
  price,
  selected,
  onToggle,
  signColor,
  isBundle = false
}: ArtifactCardProps) {
  return <motion.div onClick={onToggle} className={`relative cursor-pointer rounded-xl border-2 p-6 transition-all duration-300 ${selected ? 'border-opacity-100' : 'border-opacity-30'}`} style={{
    borderColor: signColor,
    boxShadow: selected ? `0 0 30px ${signColor}40` : `0 0 10px ${signColor}20`,
    backgroundColor: selected ? `${signColor}10` : '#14141a'
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-213">
      {/* Icon */}
      <div className="absolute top-4 right-4" data-id="element-214">
        {selected ? <motion.div initial={{
        scale: 0,
        rotate: -180
      }} animate={{
        scale: 1,
        rotate: 0
      }} transition={{
        type: 'spring',
        stiffness: 200
      }} data-id="element-215">
            <CheckCircleIcon size={28} style={{
          color: signColor
        }} data-id="element-216" />
          </motion.div> : <LockIcon size={24} className="text-gray-500" data-id="element-217" />}
      </div>

      {/* Content */}
      <div className="pr-12" data-id="element-218">
        <h3 className={`text-xl font-serif font-semibold mb-2 ${isBundle ? 'text-gold-light' : 'text-white'}`} data-id="element-219">
          {title}
        </h3>
        <p className="text-gray-300 text-sm mb-4 leading-relaxed" data-id="element-220">
          {description}
        </p>
        <p className="text-2xl font-bold" style={{
        color: signColor
      }} data-id="element-221">
          {price}
        </p>
      </div>

      {/* Particle effect on selection */}
      {selected && <motion.div className="absolute inset-0 pointer-events-none rounded-xl overflow-hidden" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-222">
          {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 rounded-full" style={{
        backgroundColor: signColor
      }} initial={{
        x: '50%',
        y: '50%',
        opacity: 1
      }} animate={{
        x: `${50 + Math.cos(i / 8 * Math.PI * 2) * 100}%`,
        y: `${50 + Math.sin(i / 8 * Math.PI * 2) * 100}%`,
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-223" />)}
        </motion.div>}
    </motion.div>;
}